import StableHashCode from "utils/StableHashCode";
import LayerToggleUtil from "utils/LayerToggleUtil";
let calcHashCode = (layerInfo) =>
  StableHashCode(layerInfo.id || layerInfo.url || layerInfo.title);
let MAP_LAYER_HASH_TABLE = undefined;
let MAP_LAYER_LIST = undefined;
let CATEGORY_LUT = undefined;
let lastMapListPtr = undefined;
/**
 * The functions in this class is useful when you need to restore the layer settings to a specified state
 */
class BookmarkUtils {
  static calcHashCode = calcHashCode;

  static prepareLayerHashTable(mapList) {
    let allLayers = mapList;
    if (lastMapListPtr == allLayers) return;
    MAP_LAYER_HASH_TABLE = {};
    CATEGORY_LUT = {};
    var addHashCode = function(layerInfo) {
      let hashCode = calcHashCode(layerInfo);
      MAP_LAYER_HASH_TABLE[hashCode] = layerInfo;
      return hashCode;
    };
    allLayers.basemaps.forEach((i) => addHashCode(i));
    allLayers.layer2D.forEach((i) => addHashCode(i));
    let layer3DCategories = Object.keys(allLayers.layer3D);
    Object.values(allLayers.layer3D).forEach((i, k) =>
      i.forEach((j) => (CATEGORY_LUT[addHashCode(j)] = layer3DCategories[k]))
    );
    allLayers.overlays.forEach((i) => {
      addHashCode(i);
      if (i.lyType == "group") i.layers.forEach((j) => addHashCode(j));
    });
    MAP_LAYER_LIST = Object.values(MAP_LAYER_HASH_TABLE);
    console.debug(MAP_LAYER_HASH_TABLE, CATEGORY_LUT, MAP_LAYER_LIST);
    lastMapListPtr = allLayers;
  }

  static toJson(mapView, is3D, saveUnenabled) {
    var json = {};

    json.viewpoint = mapView.viewpoint.toJSON();
    json.viewpoint.targetGeometry.type = mapView.viewpoint.targetGeometry.type;

    let { basemaps, layer2D, layer3D, overlays } = lastMapListPtr;
    json.basemaps = calcHashCode(basemaps.find((i) => i.layer.visible));
    let enabled2D = layer2D.find((i) => i.layer.visible);
    if (enabled2D) {
      json.layer2D = [
        calcHashCode(enabled2D),
        enabled2D.layer.opacity,
        enabled2D.layer.allSublayers.map((i) => (i.visible ? 1 : 0)).toArray(),
      ];
    }
    json.overlays = overlays.reduce((p, c, i) => {
      if (c.layer.visible) {
        p.push([
          calcHashCode(c),
          c.layer.opacity,
          c.layers && calcHashCode(c.layers.find((j) => j.layer.visible)),
        ]);
      }
      return p;
    }, []);
    json.layer3D =
      is3D &&
      Object.values(layer3D)
        .flat()
        .reduce((p, c, i) => {
          if (c.layer && (c.layer.visible || saveUnenabled))
            p.push([calcHashCode(c), c.layer.visible ? 1 : 0, c.layer.opacity]);
          return p;
        }, []);
    json.layer3D = json.layer3D || [];
    json.is3D = is3D;

    return json;
  }

  static fromJson(mapView, json, preserveLayerStatus = false) {
    try {
      let layerNotFound = false;
      if (!("noZoom" in json)) {
        if (json.viewpoint) mapView.viewpoint = json.viewpoint;
        else {
          if (json.is3D) mapView.camera = json.camera;
          else {
            mapView.extent = json.extent;
            mapView.rotation = json.rotation;
          }
        }
      }

      // Turn off all 2D layer and remove all 3D model
      for (var hash in MAP_LAYER_HASH_TABLE) {
        if (preserveLayerStatus) break;
        var layerObj = MAP_LAYER_HASH_TABLE[hash];
        if (!(hash in CATEGORY_LUT)) layerObj.layer.visible = false;
        else {
          if (layerObj.layer)
            LayerToggleUtil.toggle3DLayer(
              CATEGORY_LUT[hash],
              layerObj,
              false,
              mapView
            );
        }
      }

      let { basemaps, layer2D, layer3D = [], overlays = [] } = json;

      if (!!basemaps && !!MAP_LAYER_HASH_TABLE[basemaps])
        MAP_LAYER_HASH_TABLE[basemaps].layer.visible = true;
      else lastMapListPtr.basemaps[0].layer.visible = true;

      if (!!layer2D) {
        let layer2DObj = MAP_LAYER_HASH_TABLE[layer2D[0]];
        if (layer2DObj?.layer) {
          layer2DObj = layer2DObj.layer;
          layer2DObj.visible = true;
          layer2DObj.opacity = layer2D[1];
          layer2DObj.when(() =>
            layer2DObj.allSublayers.forEach(
              (i, j) => (i.visible = layer2D[2][j] == 1)
            )
          );
        } else {
          console.debug("2d layer missing!", layer2D[0]);
          layerNotFound = true;
        }
      }

      overlays.forEach((i) => {
        let overlayObj =
          typeof i[0] === "object" ? i[0] : MAP_LAYER_HASH_TABLE[i[0]];
        if (overlayObj?.layer) {
          overlayObj = overlayObj.layer;
          overlayObj.visible = typeof i[3]==="undefined";
          overlayObj.opacity = i[1];
          if (i[2]) {
            if ("layers" in overlayObj)
              overlayObj.layers.forEach((i) => i.visible == false);
            if (i[2] !== "first")
              MAP_LAYER_HASH_TABLE[i[2]].layer.visible = true;
            else overlayObj.layers.items[0].visible = true;
          }
        } else {
          console.debug("overlays layer missing!", i[0]);
          layerNotFound = true;
        }
      });
      // ...And turn on the first layer of
      lastMapListPtr.overlays.forEach(
        (i) =>
          i.layer &&
          i.layers &&
          !i.layers.some((j) => j.visible) &&
          (i.layers[0].layer.visible = true)
      );

      layer3D.forEach((i) => {
        let layer3DObj =
          typeof i[0] === "object" ? i[0] : MAP_LAYER_HASH_TABLE[i[0]];
        if (!layer3DObj) {
          layerNotFound = true;
          return;
        }
        LayerToggleUtil.toggle3DLayer(
          CATEGORY_LUT[i[0]],
          layer3DObj,
          true,
          mapView,
          undefined,
          i[1] == 1
        );
        try {
          layer3DObj.layer.opacity = i[2];
        } catch (e) {
          // Not every 3D layer allows to set opacity
        }
      });
    } catch (e) {
      mapView.map.basemap.baseLayers.items[0].visible = true;
      throw e;
    }
  }
}
export default BookmarkUtils;
